import { usePageView } from "@kupikupi/analytics/react";
import { Outlet, useRouterState } from "@tanstack/react-router";

/**
 * Root layout · the Telegram WebView is full-bleed, so we don't need
 * the design's `.tg-frame` mockup chrome. Just an outlet — each route
 * provides its own header/body/tabbar/CTA via TgPage primitives.
 */
export function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  usePageView(pathname);
  return <Outlet />;
}
